import { useState } from 'react';
import { useModal } from '../../../../hooks';
import type { TaskDetails } from '../../../../services/scraper';

export const useScrapingModals = () => {
  const { isOpened, onClose, onOpen } = useModal();
  const {
    isOpened: isDeleteModalOpen,
    onClose: onCloseDeleteModal,
    onOpen: onOpenDeleteModal,
  } = useModal();
  const {
    isOpened: isBulkDeleteModalOpen,
    onClose: onCloseBulkDeleteModal,
    onOpen: onOpenBulkDeleteModal,
  } = useModal();
  const {
    isOpened: isInfoModalOpen,
    onClose: onCloseInfoModal,
    onOpen: onOpenInfoModal,
  } = useModal();
  const {
    isOpened: isErrorModalOpen,
    onClose: onCloseErrorModal,
    onOpen: onOpenErrorModal,
  } = useModal();
  const {
    isOpened: isDownloadModalOpen,
    onClose: onCloseDownloadModal,
    onOpen: onOpenDownloadModal,
  } = useModal();
  const {
    isOpened: isUploadScreenshotModalOpen,
    onClose: onCloseUploadScreenshotModal,
    onOpen: onOpenUploadScreenshotModal,
  } = useModal();

  const [deleteTaskId, setDeleteTaskId] = useState<string | null>(null);
  const [selectedTask, setSelectedTask] = useState<TaskDetails | null>(null);
  const [errorTask, setErrorTask] = useState<TaskDetails | null>(null);
  const [downloadModalTaskId, setDownloadModalTaskId] = useState<string | null>(
    null
  );
  const [uploadScreenshotTaskId, setUploadScreenshotTaskId] = useState<
    string | null
  >(null);

  const handleDeleteClick = (taskId: string) => {
    setDeleteTaskId(taskId);
    onOpenDeleteModal();
  };

  const handleCloseDeleteModal = () => {
    setDeleteTaskId(null);
    onCloseDeleteModal();
  };

  const handleInfoClick = (task: TaskDetails) => {
    setSelectedTask(task);
    onOpenInfoModal();
  };

  const handleCloseInfoModal = () => {
    setSelectedTask(null);
    onCloseInfoModal();
  };

  const handleErrorClick = (task: TaskDetails) => {
    setErrorTask(task);
    onOpenErrorModal();
  };

  const handleCloseErrorModal = () => {
    setErrorTask(null);
    onCloseErrorModal();
  };

  const handleBulkDeleteClick = () => {
    onOpenBulkDeleteModal();
  };

  const handleCloseBulkDeleteModal = () => {
    onCloseBulkDeleteModal();
  };

  return {
    isOpened,
    onOpen,
    onClose,
    deleteTaskId,
    setDeleteTaskId,
    isDeleteModalOpen,
    handleDeleteClick,
    handleCloseDeleteModal,
    isBulkDeleteModalOpen,
    handleBulkDeleteClick,
    handleCloseBulkDeleteModal,
    selectedTask,
    isInfoModalOpen,
    handleInfoClick,
    handleCloseInfoModal,
    errorTask,
    isErrorModalOpen,
    handleErrorClick,
    handleCloseErrorModal,
    isDownloadModalOpen,
    onOpenDownloadModal,
    onCloseDownloadModal,
    downloadModalTaskId,
    setDownloadModalTaskId,
    isUploadScreenshotModalOpen,
    onOpenUploadScreenshotModal,
    onCloseUploadScreenshotModal,
    uploadScreenshotTaskId,
    setUploadScreenshotTaskId,
  };
};
